import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import GraphicPreview from './GraphicPreview';

const Container = styled.div`
  position: absolute;
  text-align: center;
  height: 360px;
  width: 100%;
  z-index: 2;
`;

class GraphicPreviewContainer extends React.Component {
  render() {
    if (this.props.currentGraphics.length > 0) {
      return (
        <Container>
          {
            this.props.currentGraphics.map((graphic, index) => (
              <GraphicPreview key={graphic.id} index={index} src={graphic.previewImgUrl} />
            ))
          }
        </Container>
      );
    }

    return null;
  }
}

GraphicPreviewContainer.defaultProps = {
  currentGraphics: []
};

GraphicPreviewContainer.propTypes = {
  currentGraphics: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    previewImgUrl: PropTypes.string
  })).isRequired
};

const mapStateToProps = (state) => {
  const currentPosition = state.clipperMovie.currentPosition;
  const currentGraphics = state.clipperMovie.timelineGraphics.filter(
    g => g.start <= currentPosition && g.end >= currentPosition);

  return {
    currentGraphics
  };
};

export default connect(mapStateToProps)(GraphicPreviewContainer);



// WEBPACK FOOTER //
// ./app/components/Clipper/GraphicPreviewContainer.js